"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUESSpecialityTranslationsEN = getUESSpecialityTranslationsEN;
exports.getNewPESRollUpSpecialityTranslationsEN = getNewPESRollUpSpecialityTranslationsEN;
exports.getUesAoeTranslationsEN = getUesAoeTranslationsEN;
exports.getEnglishModule = getEnglishModule;
exports.getModuleOrDefault = getModuleOrDefault;
exports.getCurrentLocale = getCurrentLocale;
exports.getDynamicContentLocale = getDynamicContentLocale;
var node_fetch_1 = __importDefault(require("node-fetch"));
// Added for the native app, Metro doesn't support dynamic requires
function getUESSpecialityTranslationsEN() {
    return require("../data/en/uesSpecialityTranslations.json");
}
function getNewPESRollUpSpecialityTranslationsEN() {
    return require("../data/en/newPesRollUpSpecialityTranslations.json");
}
function getUesAoeTranslationsEN() {
    return require('../data/en/uesAoeTranslation.json');
}
function getEnglishModule(fileName) {
    return require("../data/en/".concat(fileName, ".json"));
}
function getModuleOrDefault(localeCode, fileName) {
    return __awaiter(this, void 0, void 0, function () {
        var url, CACHED_JSON, response, data, filteredData, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 6]);
                    url = "https://lagoon-web-psx.uhc.com/specialty/dev/".concat(localeCode, "/").concat(fileName, ".json");
                    CACHED_JSON = {};
                    if (CACHED_JSON[url] != null) {
                        return [2 /*return*/, CACHED_JSON[url]];
                    }
                    return [4 /*yield*/, (0, node_fetch_1.default)(url)];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    CACHED_JSON[url] = data;
                    if (data && data.globallink) {
                        filteredData = Object.fromEntries(Object.entries(data).filter(function (_a) {
                            var key = _a[0];
                            return key !== 'globallink';
                        }));
                        return [2 /*return*/, filteredData];
                    }
                    return [2 /*return*/, data];
                case 3:
                    error_1 = _a.sent();
                    if (!((error_1 === null || error_1 === void 0 ? void 0 : error_1.code) === 'MODULE_NOT_FOUND')) return [3 /*break*/, 5];
                    return [4 /*yield*/, getModuleOrDefault('en', fileName)];
                case 4: return [2 /*return*/, _a.sent()];
                case 5: throw error_1;
                case 6: return [2 /*return*/];
            }
        });
    });
}
/**
 * Get the current two-character locale (e.g. 'en' or 'es')
 */
function getCurrentLocale(locale) {
    if (locale === void 0) { locale = 'en'; }
    return locale.slice(0, 2);
}
/**
 * Get the current locale with fallback to 'en'.
 * @description
 * Since we currently only have english and spanish files for dynamic content,
 * we should default to english so content will still appear for users with other locales set
 */
function getDynamicContentLocale(locale) {
    var localeCode = getCurrentLocale(locale);
    if (['en', 'es', 'my', 'ht', 'ic', 'ko', 'vi', 'zh'].includes(localeCode)) {
        return localeCode;
    }
    return 'en';
}
function getDynamicContentPaths(locale) {
    return __awaiter(this, void 0, void 0, function () {
        var localeCode;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    localeCode = getDynamicContentLocale(locale);
                    _a = {};
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'accessibilityTranslations')];
                case 1:
                    _a.accessibility = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'accreditationTranslations')];
                case 2:
                    _a.accreditation = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'ageTranslations')];
                case 3:
                    _a.age = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'aoeTranslations')];
                case 4:
                    _a.aoe = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'uesAoeTranslation')];
                case 5:
                    _a.aoeDetails = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'behaviouralProgramsTranslations')];
                case 6:
                    _a.behaviouralPrograms = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'culturalCompetencyTranslations')];
                case 7:
                    _a.culturalCompetency = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'culturalCompetencyCategoriesTranslations')];
                case 8:
                    _a.culturalCompetencyCategories = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'carePathCategoryTranslations')];
                case 9:
                    _a.carePathCategory = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'degreeTranslations')];
                case 10:
                    _a.degree = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'ethnicityTranslations')];
                case 11:
                    _a.ethnicityCode = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'hcbsWaiversTranslations')];
                case 12:
                    _a.hcbsWaivers = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'raceTranslations')];
                case 13:
                    _a.raceCode = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'behavioralFacilityProgramsTranslations')];
                case 14:
                    _a.behavioralFacilityPrograms = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'platinumProgramsTranslations')];
                case 15:
                    _a.platinumPrograms = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'facilityServiceCodeTranslations')];
                case 16:
                    _a.facilityServiceCode = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'facilitySubCategoryCodeTranslations')];
                case 17:
                    _a.facilitySubCategoryCode = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'genderTranslations')];
                case 18:
                    _a.gender = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'languageTranslations')];
                case 19:
                    _a.language = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'preferredFacilityTranslations')];
                case 20:
                    _a.preferredFacility = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'pesSpecialityTranslations')];
                case 21:
                    _a.pesSpecialty = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'pesFacilityTranslations')];
                case 22:
                    _a.pesFacility = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'qualityRatingTranslations')];
                case 23:
                    _a.qualityRating = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'leapFrogRatingCategories')];
                case 24:
                    _a.leapFrogRatings = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'sourceSystemSpecialityTranslations')];
                case 25:
                    _a.sourceSystemSpecialty = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'servicesOfferedTranslations')];
                case 26:
                    _a.servicesOffered = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'accommodateOfferedTranslations')];
                case 27:
                    _a.accommodateOffered = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'methodsOfServiceTranslations')];
                case 28:
                    _a.methodsOfService = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'uesSpecialityTranslations')];
                case 29:
                    _a.uesSpecialty = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'newPesRollUpSpecialityTranslations')];
                case 30:
                    _a.newPesRollUpSpecialty = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'virtualCareTranslations')];
                case 31:
                    _a.virtualCare = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'virtualCareOptionsTranslations')];
                case 32:
                    _a.virtualCareOptions = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'virtualCareProviderSearchTranslations')];
                case 33:
                    _a.virtualCareProviderSearch = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'ddpTranslations')];
                case 34:
                    _a.ddp = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'costExperienceCarePathsTranslations')];
                case 35:
                    _a.carePathSteps = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'docAsapAvailabilityTranslations')];
                case 36:
                    _a.docAsapAvailability = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'servicesProvidedTranslations')];
                case 37:
                    _a.servicesProvided = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'uesAoeTranslation')];
                case 38:
                    _a.uesAoe = (_b.sent());
                    return [4 /*yield*/, getModuleOrDefault(localeCode, 'licensedStatesTranslations')];
                case 39: return [2 /*return*/, (_a.licensedStates = (_b.sent()),
                        _a)];
            }
        });
    });
}
exports.default = getDynamicContentPaths;
